import script from "./ParametersComposer.vue?vue&type=script&lang=js"
export * from "./ParametersComposer.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__